import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { HelpersService } from 'src/app/services/helpers/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {

  constructor(
    private authService: AuthService,
    private router: Router,
    private helpers: HelpersService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      console.log(this.authService);
      let user = this.authService.getUser();
      let token = this.authService.getUserToken();
      if (!(token)){
        this.router.navigateByUrl('login');
        return false;
      }
      if (!(user)){
        this.helpers.presentNoPrivateInfo();
        return false;
      }
      return true;
  }
  
}
